import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { AdminLayout } from '../components/AdminLayout';

export const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <AdminLayout title={t('dashboard.title')} subtitle={t('dashboard.welcomeBack', { username: user?.name })}>
      <div className="">
        {/* System Information */}
        <div className="bg-white rounded-xl p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900 mb-5">{t('dashboard.systemInfo')}</h3>
          <div className="space-y-0">
            <div className="flex justify-between items-center py-3 border-b border-gray-100 last:border-b-0">
              <span className="text-gray-500 font-medium">{t('dashboard.userType')}</span>
              <span className="bg-[var(--gold-pale)] text-[var(--gold-dim)] px-3 py-1 rounded-full text-xs font-semibold">
                Admin
              </span>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};
